import { useEffect, useMemo, useState } from 'react';

export const useEmptyDetails = ({data, empty, loading, query} = {}) => {

  const [emptyDetails, setEmptyDetails] = useState({ text: '', enabled: false });

  const isEnabledEmpty = useMemo(
    () => empty && query?.search === '' && data?.length === 0 && !loading,
    [data, empty, loading, query]
  );

  useEffect(() => {
    const isEmptyList = data.length === 0;
    const search = query?.search || '';
    if (isEmptyList) {
      setEmptyDetails({ enabled: search !== '', text: search });
    } else if (emptyDetails.enabled && !isEmptyList) {
      setEmptyDetails({ ...emptyDetails, enabled: false });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return { emptyDetails, setEmptyDetails, isEnabledEmpty };
}
